import { instance } from "libs/api";

import { ApiRoutesRecommendation } from "../../constants";
import { AvailableEnrichmentProfile } from "../../recommendation.types";

export const requestGetAvailableEnrichmentProfiles = async (): Promise<
  AvailableEnrichmentProfile[]
> => {
  return await instance.get(
    ApiRoutesRecommendation.EnrichmentProfilesAvailable
  );
};
